
import {initWebComponent} from "@/helpers/web-component-helper";
import {disableCesium, getCesium, initCesium} from "@/modules/cesium/cesium";
import {hideActiveToolButtons, toggleActiveToolButton} from "@/helpers/layer-tools-helper";
import {enableCesium, toggleCesium} from "@/helpers/cesium/cesium-helper";
import {startTour} from "@/helpers/tour/tour-helper";

const template = document.createElement('template');
template.innerHTML = `<footer-button data-title="Open in 3D, gebruik Ctrl-toets om te kantelen" data-text="3D">`;

export class CesiumEnableComponent extends HTMLElement {
    constructor(){
        super();
        initWebComponent(this, template)

        this.addEventListener('click', () => {
            toggleCesium()
        });
    }
}

